import { createModalContext, useModalState } from '@/common/app/modal'
import { AutoDraftMeta } from '@/common/model/media/mediaAction'
import { ChildProps } from '@/common/util/props'

import DecomposeResultModal from '@/components/container/modal/automationReview/DecomposeResultModal'

interface DecomposeResultModalState {
  result: AutoDraftMeta | null
}

const defaultValue: DecomposeResultModalState = { result: null }

export const DecomposeResultModalContext =
  createModalContext<DecomposeResultModalState>(defaultValue)

const DecomposeResultModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<DecomposeResultModalState>(defaultValue)
  return (
    <DecomposeResultModalContext.Provider value={state}>
      {children}
      <DecomposeResultModal />
    </DecomposeResultModalContext.Provider>
  )
}

export default DecomposeResultModalProvider
